// ags-bet-button-control-factory.ts
import { Layers } from "appworks/graphics/layers/layers";
import { ControlFactory } from "appworks/ui/factories/control-factory";
import { AgsBetButtonControl } from "../ags-bet-button-control";

export class AgsBetButtonControlFactory implements ControlFactory {
    /**
     * Determines if a Layer contains the required flexi buttons for
     * AgsBetButtonControl instances.
     * @param layer The Layers instance to check.
     * @returns A boolean indicating if the flexi buttons are present.
     */
    public filter(layer: Layers): boolean {
        return (
            layer.getFlexiButton("bet_amount_slider_up") != null &&
            layer.getFlexiButton("bet_amount_slider_down") != null
        );
    }

    /**
     * Builds AgsBetButtonControl instances based on the provided Layers instance.
     * @param layer The Layers instance to use for building the controls.
     * @returns An array of AgsBetButtonControl instances.
     */
    public build(layer: Layers): AgsBetButtonControl[] {

        const incrementBet = layer.getFlexiButton("bet_amount_slider_up");
        const decrementBet = layer.getFlexiButton("bet_amount_slider_down");

        return [
            new AgsBetButtonControl(incrementBet, true),
            new AgsBetButtonControl(decrementBet, false),
        ];
    }
}
